import { Button, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { scholarshipRequests } from "api/scholarshipApi";
import { Sync } from "@mui/icons-material";

const RecalculateDialog = ({ filters, setBudgetInfo, excludedIds }) => {
  const notify = useNotify();

  const recalculateBudget = async () => {
    const { data } = await dataProvider.customRequest(
      scholarshipRequests.getApprovedScholarshipBudgetInfo({ ...filters, excludeApplicationIds: excludedIds }),
      null,
      "GET",
    );
    setBudgetInfo(data);
    notify("Успешно преизчислихте бюджета", { type: "success" });
  };

  return (
    <ConfirmModal
      onConfirm={recalculateBudget}
      titleContent={"Преизчисляване на бюджета"}
      triggerButton={
        <Button
          label="Преизчисли"
          variant="contained"
          color="warning"
          size="medium"
          startIcon={<Sync />}
          mt={2}
        />
      }
      message="Преизчисляване на бюджета?"
    />
  );
};

export default RecalculateDialog;
